import dayjs from 'dayjs';

interface IDateOptions {
  defaultValue?: string;
  formatType?: string;
}

function date(value?: string | null, options?: IDateOptions): string {
  if (!value) {
    return options?.defaultValue || '';
  }

  const dateFormatted = dayjs(value).format(
    options?.formatType || 'DD/MM/YYYY',
  );

  return dateFormatted;
}

export default date;
